/**
 * ArticleAgeQualifier
 * The qualifier list sends each CSS selector as an array entry (rule.Value from config).
 * For each selector, reads the article published date from the DOM and sends it as an ISO string.
 *
 * The API stores item.Value → ArticlePublishedDate (last item wins).
 * CheckArticleAgeCondition uses ArticlePublishedDate with rule.EvaluatedObject (time amount)
 * and rule.Delimiter (unit: Days/Weeks/Months/Years) to check if article is older than threshold.
 * Mirrors ConneXt v2 ArticleAge.olderThan() which reads the DOM element by selector.
 */
export class ArticleAgeQualifier {
    constructor() {
        this.key = "ArticleAge";
    }
    process(config) {
        const selectors = Array.isArray(config) ? config : [];
        const results = [];
        for (const selector of selectors) {
            if (!selector)
                continue;
            const date = this.readArticleDate(selector);
            if (!date)
                continue;
            results.push({
                key: selector,
                value: date.toISOString() // item.Value → ArticlePublishedDate (parsed by API)
            });
        }
        return results;
    }
    readArticleDate(selector) {
        var _a;
        // Try selector directly, then selector + " span" (mirrors ConneXt v2)
        const candidates = [
            document.querySelector(selector),
            document.querySelector(`${selector} span`)
        ];
        for (const el of candidates) {
            if (!el)
                continue;
            // Prefer datetime attribute (semantic HTML), fall back to text content
            const raw = el.getAttribute("datetime") || ((_a = el.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || "";
            if (!raw)
                continue;
            const date = new Date(raw);
            if (!isNaN(date.getTime()))
                return date;
        }
        return null;
    }
}
